<template>
  <div>
    <small>
      Made with
      <a href="https://v3.vuejs.org/"> Vue.js 3</a> and
      <a href="https://bootstrap-vue.org/">Bootstrap Vue</a>, by @jimmie
    </small>
  </div>
</template>

<script>
export default {
  name: "Footercomponent",
};
</script>

<style scoped>
small {
  font-size: 0.7em;
}
</style>
